import { LocationLightDTO } from '../../services/location.service';
import { EntityType, VehicleLightDTO } from '../../shared/types';

export type GroupListFilterDTO = {
  search?: string;
  limit?: number;
  offset?: number;
  group?: number | string | string[];
  color?: string[];
  couriers?: string[];
  transports?: string[];
  includeLocations?: boolean;
};

export enum GroupSearchOption {
  NAME = 'name',
  COLOR = 'color',
  SCHEDULE = 'courierSchedule',
  DRIVER_FIRST_NAME = 'courier:firstName',
  DRIVER_LAST_NAME = 'courier:lastName',
  DESCRIPTION = 'description',
  TRANSPORTS = 'transport:id',
  COURIERS = 'courier:id',
}

export type GroupFormDTO = {
  id: number;
  name: string;
  transports: VehicleLightDTO[] | [];
  color?: string;
  description?: string;
  locations: {
    value: LocationLightDTO[];
    combined: { groups: number[]; locations: number[] };
  };
  type: EntityType;
};

export enum WorkingSchedule {
  'MONDAY' = 'MONDAY',
  'TUESDAY' = 'TUESDAY',
  'WEDNESDAY' = 'WEDNESDAY',
  'THURSDAY' = 'THURSDAY',
  'FRIDAY' = 'FRIDAY',
  'SATURDAY' = 'SATURDAY',
  'SUNDAY' = 'SUNDAY',
}

export enum EntityAssociationType {
  ASSIGN = 'ASSIGN',
  UNASSIGN = 'UNASSIGN',
}

export type GroupAssignmentDTO = {
  groupId: string | number;
  locationId: string;
  association: EntityAssociationType;
};
